export function buildBundle(base, parts) {
    const paymentBase = base.payment && typeof base.payment === 'object' ? base.payment : {};
    const extras = parts.versionCompare?.payment || {};
    return {
        ...base,
        ...(parts.content || {}),
        aqpro: parts.aqpro,
        firmament: parts.firmament,
        radiacodeapp: parts.radiacodeapp,
        versionExplainer: parts.versionCompare?.versionExplainer,
        payment: {
            ...paymentBase,
            ...(extras.twoVersionsTitle ? { twoVersionsTitle: extras.twoVersionsTitle } : {}),
            ...(extras.versionSelectHint ? { versionSelectHint: extras.versionSelectHint } : {}),
        },
    };
}
